import React, { useEffect, useState } from "react";
import Card from "../../../components/Card";
import {
  Container,
  Row,
  Col,
  Nav,
  Tab,
  Button,
  Image,
  Modal,
  Form,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import img1 from "../../../assets/images/page-img/profile-bg2.jpg";
import axios from "axios";
import useAuth from "../../../utils/useAuth";
import { useTranslation } from "react-i18next";
import { useConnections } from "../../../Context/ConnectionContext";
import { getToken } from "../../../utils/auth";

const Connections = () => {
  useAuth();
  const navigate = useNavigate();
  const [connection, setConnection] = useState([]);
  const [requestedto, setRequestedTo] = useState([]);
  const [requestedToCount, setRequestedToCount] = useState(0);
  const [requests, setRequests] = useState([]);
  const [requestsCount, setRequestsCount] = useState(0);
  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const { connections, handleConnections, loading, error } = useConnections();
  const location = useLocation();
    const getQueryParam = (param) => {
    return new URLSearchParams(location.search).get(param);
  };
  const tabParam = getQueryParam("tab");
  const tabMapping = {
    "1": "connections",
    "2": "requests",
    "3": "requested",
  };
  const defaultTab = tabMapping[tabParam] || "connections";

  const handleRemoveClick = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  const handleRequestedTo = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/connection/sent-request/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setRequestedTo(response.data.data);
      setRequestedToCount(response.data.data.length);
    } catch (error) {
      console.log("Failed Fetching Requested to", error);
    }
  };
  const handleRequests = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/connection/requests/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setRequests(response.data.data);
      setRequestsCount(response.data.data.length);
    } catch (error) {
      console.log("Failed Fetching Requested to", error);
    }
  };
  const handleConnection = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/connection/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setConnection(response.data.data.connectionList);
    } catch (error) {
      console.log("Failed Fetching Posts", error);
    }
  };
  useEffect(() => {
    // handleConnection();
    handleRequestedTo();
    handleRequests();
  }, []);

  const handleNavigateProfile = (userid) => {
    navigate(`/userprofile/${userid}`);
  };
  const handleNavigateProfileRequest = (userid) => {
    navigate(`/userprofile/${userid}`);
  };

  const handleRequestApprove = async (reqid, action) => {
    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/connection/request/${reqid}`,
        {
          status: action,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      handleConnections();
      handleRequestedTo();
      handleRequests();
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
      console.log("Failed fetching connection", error);
    }
  };
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [inputValue, setInputValue] = useState("");
  const [strings, setStrings] = useState([]);

  const handleAdd = (e) => {
    e.preventDefault();
    const emails = inputValue.split(/[\s,]+/).filter(email => email.trim() && validateEmail(email.trim()));
    if (emails.length > 0) {
      setStrings([...strings, ...emails]);
      setInputValue("");
    } else {
      toast.error("Please enter valid email addresses.");
    }
  };

  const handleSubmit = async () => {
    if (strings.length === 0) {
      toast.error("Please add email addresses.");
      return;
    }
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/user/invite`,
        {
          emailIds: strings,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response.data.message);
      setInputValue("");
      setStrings([]);
      handleClose1();
    } catch (error) {
      toast.error(error.response.data.message);
      console.log("Failed sending invitation", error);
    }
  };

  const handleConfirmRemove = async () => {
    if (!selectedUser){
      toast.error("Please try later.");
      return;
    }

    try {
      const token = getToken();
      const response = await axios.delete(
        `${process.env.REACT_APP_URL}/api/connection/remove/${selectedUser}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "accept": "*/*",
          },
        }
      );
      handleConnections();
      toast.success(response?.data?.message || `Successfully removed user`);
      setShowModal(false);
      setSelectedUser(null);
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error(error?.response?.data?.message || "Error removing friend");
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };


  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
{/* <ProfileHeader title="Store Category" img={profilebg7}/> */}
      <div id="content-page" className="content-page">
        <Container>
          <Row>
            <Col lg="12">
              <Tab.Container defaultActiveKey={defaultTab}>
                <Card className="cardnavbar">
                  <div className="user-tabing">
                   <Nav
  variant="pills"
  className="connection-tabs-nav p-0 m-0 round"
>
  <Nav.Item as="li">
    <Nav.Link
      className="text-center"
      eventKey="connections"
      href="#"
    >
      {t('connections')}
    </Nav.Link>
  </Nav.Item>

  <Nav.Item as="li">
    <Nav.Link
      className="text-center"
      eventKey="requests"
      href="#"
    >
      {/* {t('follow_requests')} */}
      {t("requests")}
    </Nav.Link>
  </Nav.Item>

  <Nav.Item as="li">
    <Nav.Link
      className="text-center"
      eventKey="requested"
      href="#"
    >
      {t('pending')}
    </Nav.Link>
  </Nav.Item>
</Nav>
                  </div>
                </Card>
                <Tab.Content className="forum-content">
                  <Tab.Pane eventKey="connections">
                    <div >
                      <div style={{ marginBottom: "15px", display: "flex" }}>
                        <button
                          type="submit"
                          style={{
                            width: "150px",
                            display: "flex",
                            marginLeft: "auto",
                          }}
                          className="btn btn-primary d-block "
                          onClick={handleShow1}
                        >
                          {t('invite')}
                        </button>
                      </div>
                      <Modal
      size="md"
      id="post-modal"
      onHide={handleClose1}
      show={show1}
      centered
    >
      <Modal.Header className="d-flex justify-content-between">
        <Modal.Title id="post-modalLabel">
        {t('invite_friends_contacts')}
        </Modal.Title>
        <Link to="#" className="lh-1" onClick={handleClose1}>
          <span className="material-symbols-outlined">
            close
          </span>
        </Link>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "450px", overflowY: "auto" }}>
        <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0">
          <li className="col-12">
             <Form.Group className="form-group">
      <Form.Label>
      {t('email_placeholder')}
      </Form.Label>
      <div className="d-flex">
        <form
          onSubmit={handleAdd}
          style={{
            gap: "10px",
            display: "flex",
            flexDirection: "row",
            width: "100%",
          }}
        >
          <Form.Control
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            className="mb-0 py-2"
            style={{ width: "80%" }}
            placeholder={t('email_placeholder')}
            required
          />
          <button
            type="submit"
            style={{ width: "20%" }}
            className="btn btn-secondary ml-2"
          >
            {t('add')}
          </button>
        </form>
      </div>
    </Form.Group>
          </li>
        </ul>
        {strings.length > 0 && (
        <ul style={{maxHeight:"200px", overflowY:"auto", border:"1px solid #d4d4d4", borderRadius:"10px", display:"flex", flexDirection:"column"}}>
          {strings.map((str, index) => (
            <li key={index}>{str}</li>
          ))}
        </ul>)}
        <button
          type="submit"
          className="btn btn-primary d-block w-100 mt-3"
          onClick={handleSubmit}
        >
          {t('send_invitation')}
        </button>
      </Modal.Body>
    </Modal>
<div style={{ display: "flex", flexWrap: "wrap" }}>
  {connections?.length === 0 ? (
    <Col xs={12}>
      <Card className="text-center p-4">
        <Card.Body>
          <img
            loading="lazy"
            src="/noconnection.png"
            alt="no-connections"
            style={{ width: "220px", height: "auto" }}
          />
          <h5 className="mt-3">{t("noConnectionsFound")}</h5>
        </Card.Body>
      </Card>
    </Col>
  ) : (
    connections?.map((data, index) => {
      const userDetails =
        data?.userId || data?.connectionUserId || {};

      return (
        <Col xs={12} md={6} key={index} className="p-1">
          <Card
            className="p-2"
            style={{
              borderRadius: "12px",
              boxShadow: "0px 3px 10px rgba(0,0,0,0.07)",
              width: "100%",
            }}
          >
            <Card.Body className="p-2">

              {/* Single-line compact layout */}
              <div className="d-flex align-items-center justify-content-between">

                {/* Profile Image + Name */}
                <div className="d-flex align-items-center">
                  <img
                    loading="lazy"
                    src={userDetails.profileImageLink || "/profile.png"}
                    alt="profile-img"
                    className="rounded-circle me-3"
                    style={{
                      width: "55px",
                      height: "55px",
                      objectFit: "cover",
                      border: "2px solid #f0f0f0",
                    }}
                  />

                  <h6
                    className="m-0"
                    style={{ cursor: "pointer", fontWeight: 600 }}
                    onClick={() => handleNavigateProfile(userDetails?.UID)}
                  >
                    {userDetails?.firstName} {userDetails?.lastName}
                  </h6>
                </div>

                {/* Remove Button */}
                <button
                  className="btn btn-outline-danger btn-sm"
                  style={{ borderRadius: "6px", padding: "3px 10px" }}
                  onClick={() => handleRemoveClick(data?._id)}
                >
                  {t("remove")}
                </button>
              </div>

            </Card.Body>
          </Card>
        </Col>
      );
    })
  )}
</div>



                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="requests">
                    {/* <Row> */}
                      <Col>
                        <Card className="shadow-none m-0">
                          <Card.Header className="d-flex justify-content-between bg-primary">
                            <div className="header-title">
                              <h5 className="mb-0 text-white">
                              {t('friend_request')}
                              </h5>
                            </div>
                            <small className="badge  bg-light text-dark ">
                              {requestsCount}
                            </small>
                          </Card.Header>
                          <Card.Body className="p-0">
                            {requests?.length === 0 ? (
                              <Col>
                                <div className="text-center">
                                  <h5 style={{ color: "gray" }}>{t('no_requests')}</h5>
                                </div>
                              </Col>
                            ) : (
                              requests?.map((data, index) => (
                                <div
                                  className="iq-friend-request"
                                  style={{
                                    padding: "10px 0px 10px 15px",
                                    marginInline: "10px",
                                    borderBottom: "1px solid #D3D3D3",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div style={{ display: "flex" }}>
                                      <Image
                                        className="avatar-40 rounded"
                                        src={
                                          data?.requestBy?.profileImageLink
                                            ? data?.requestBy?.profileImageLink
                                            : "/profile.png"
                                        }
                                        alt=""
                                        loading="lazy"
                                      />
                                      <div
                                        className="ms-3 text-primary"
                                        style={{
                                          alignItems: "center",
                                          display: "flex",
                                          fontSize: "18px",
                                          cursor:"pointer",
                                          
                                        }}
                                        onClick={()=>handleNavigateProfileRequest(data?.requestBy?.UID)}
                                      >
                                        {data?.requestBy?.firstName}{" "}
                                        {data?.requestBy?.lastName}
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Link
                                        to="#"
                                        className="me-3 btn btn-primary rounded"
                                        onClick={() =>
                                          handleRequestApprove(
                                            data?._id,
                                            "accept"
                                          )
                                        }
                                      >
                                        {t('confirm')}
                                      </Link>
                                      <Link
                                        to="#"
                                        onClick={() =>
                                          handleRequestApprove(
                                            data?._id,
                                            "reject"
                                          )
                                        }
                                        className="me-3 btn btn-secondary rounded"
                                      >
                                        {t('delete_request')}
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              ))
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    {/* </Row> */}
                  </Tab.Pane>
                  <Tab.Pane eventKey="requested">
                    {/* <Row> */}
                      <Col>
                        <Card className="shadow-none m-0">
                          <Card.Header className="d-flex justify-content-between bg-primary">
                            <div className="header-title">
                              <h5 className="mb-0 text-white">
                                {t('friend_request_send_to')}
                              </h5>
                            </div>
                            <small className="badge  bg-light text-dark ">
                              {requestedToCount}
                            </small>
                          </Card.Header>
                          <Card.Body className="p-0">
                            {requestedto?.length === 0 ? (
                              <Col>
                                <div className="text-center">
                                  <h5 style={{ color: "gray" }}>
                                    {t('no_request_send')}
                                  </h5>
                                </div>
                              </Col>
                            ) : (
                              requestedto?.map((data, index) => (
                                <div
                                  className="iq-friend-request"
                                  style={{
                                    padding: "10px 0px 10px 15px",
                                    marginInline: "10px",
                                    borderBottom: "1px solid #D3D3D3",
                                  }}
                                  key={index}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div style={{ display: "flex" }}>
                                      <Image
                                        className="avatar-40 rounded"
                                        src={
                                          data?.requestTo?.profileImageLink
                                            ? data?.requestTo?.profileImageLink
                                            : "/profile.png"
                                        }
                                        alt=""
                                        loading="lazy"
                                      />
                                      <div className="ms-3">
                                        <h6 className="mb-0 ">
                                          {data?.requestTo?.firstName}{" "}
                                          {data?.requestTo?.lastName}
                                        </h6>
                                        <p
                                          className="mb-0"
                                          style={{
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {data?.status}
                                        </p>
                                      </div>
                                    </div>
                              
                                  </div>
                                </div>
                              ))
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    {/* </Row> */}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal size="md" id="post-modal" centered show={showModal} onHide={handleClose}>
        <Modal.Header className="d-flex justify-content-between">
          <Modal.Title id="post-modalLabel">{t("removeFriend")}</Modal.Title>
          <Link to="#" className="lh-1" onClick={handleClose}>
            <span className="material-symbols-outlined">close</span>
          </Link>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "450px", overflowY: "auto" }}>
          <p>{t("confirmRemoveFriend")} {selectedUser?.firstName} {selectedUser?.lastName} {t("asAFriend")}?</p>
          <button
            type="button"
            className="btn btn-primary d-block w-100 mt-3"
            onClick={handleConfirmRemove}
          >
            {t("confirm")}
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Connections;
